export const isEnglishText = (text: string): boolean => !!text.replace(/(#|"|\s|\*|\.)/g, '').match(/^[a-zA-Z]/);
